var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStyleTextTransformUppercase(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "#323C47",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41566 3.33301C5.85056 3.33301 6.2356 3.6141 6.36811 4.02833L8.88906 11.909C9.00922 12.2846 8.72196 12.6663 8.31912 12.6663H7.77895C7.51777 12.6663 7.2869 12.5005 7.209 12.257L6.59353 10.333H3.90646L3.29076 12.2577C3.21286 12.5012 2.98222 12.6663 2.72105 12.6663H2.18087C1.77803 12.6663 1.49077 12.2846 1.61093 11.909L4.13188 4.02833C4.26439 3.6141 4.64943 3.33301 5.08433 3.33301H5.41566ZM4.27966 9.16634L5.24999 5.33301L6.22033 9.16634H4.27966Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4157 3.33301C11.8506 3.33301 12.2356 3.6141 12.3681 4.02833L14.8891 11.909C15.0092 12.2846 14.722 12.6663 14.3191 12.6663H13.7789C13.5178 12.6663 13.2869 12.5005 13.209 12.257L12.5935 10.333H9.90646L9.29076 12.2577C9.21286 12.5012 8.98222 12.6663 8.72105 12.6663H8.18087C7.77803 12.6663 7.49077 12.2846 7.61093 11.909L10.1319 4.02833C10.2644 3.6141 10.6494 3.33301 11.0843 3.33301H11.4157ZM10.2797 9.16634L11.25 5.33301L12.2203 9.16634H10.2797Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStyleTextTransformUppercase);
export default __webpack_public_path__ + "static/media/styleTextTransformUppercase.bd6a1e6e.svg";
export { ForwardRef as ReactComponent };